<div class="layout-container" [ngClass]="containerClass">
    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>
        <div class="layout-breadcrumb pt-3 pb-3">
            <app-breadcrumb class="topbar-breadcrumb"></app-breadcrumb>
        </div>

        <div class="grid">
            <div class="col-fixed">
                <app-sidebar [userAD]="userAd"></app-sidebar>
            </div>
            <div class="col layout-content" >
                <router-outlet *ngIf="userAd; else contentLoading"></router-outlet>
                <ng-template #contentLoading>
                    <div class="layout-preloader-container">
                        <div class="layout-preloader">
                            <span></span>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>

    </div>
    <app-profilemenu *ngIf="userAd"></app-profilemenu>
    <app-Notifications-sidebar *ngIf="userAd"></app-Notifications-sidebar>
</div>

<app-loader></app-loader>